module.exports = __webpack_public_path__ + "static/media/unnamed (2).a0fc988a.webp";